import { createAsyncThunk } from "@reduxjs/toolkit";
import { offlineSearchSuggestion } from "../offlineSearchService/index.js";
import { searchApi } from "../../../api/searchApi.js";
import {
  setApiReachable,
  setApiUnreachable,
} from "../../networkStatus/networkStatusSlice.js";
import offlineOrTimeoutPromise from "../utils/offlineOrTimeoutPromise.js";
import updateFirstCalculatorUrl from "../utils/updateFirstCalculatorUrl.js";

const returnPayload = (suggestionArray, online) => ({
  suggestions: suggestionArray,
  isOffline: !online,
});

export const allSuggestionsThunk = createAsyncThunk(
  'enhancedSearch/allSuggestions',
  async (arg, { dispatch }) => {
    const { searchText } = arg;
    try {
      const suggestionApiPromise = searchApi.allSuggestion(searchText);
      let suggestionArray = await Promise.race([
        suggestionApiPromise,
        offlineOrTimeoutPromise(),
      ]);
      dispatch(setApiReachable());

      if (suggestionArray.length > 0) {
        suggestionArray = updateFirstCalculatorUrl(suggestionArray);
      }
      return returnPayload(suggestionArray, true);
    } catch (error) {
      dispatch(setApiUnreachable());
      try {
        const offlineArray = await offlineSearchSuggestion(searchText);
        return returnPayload(offlineArray, false);
      } catch (offlineError) {
        console.error(
          "Offline search also failed for suggestions:",
          offlineError
        );
        return returnPayload([], false);
      }
    }
  }
);